import React from 'react';
import { useParams } from 'react-router-dom';

const EmployeeThankYou = () => {
  let {employeeId} = useParams();
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-green-100 to-green-50 p-4">
      <div className="bg-white shadow-2xl rounded-2xl p-8 md:p-12 max-w-lg text-center">
        <div className="text-green-500 mb-4">
          <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Thank You!</h1>
        <p className="text-gray-600 mb-4">Employee ID: <span className="font-semibold text-gray-800">{employeeId}</span></p>

        <p className="text-gray-700 mb-4 leading-relaxed">
          You have successfully submitted your details and uploaded your documents.
          Your information will now go through verification and background checks.
        </p>

        <p className="text-gray-700 mb-4 leading-relaxed">
          Once the verification is complete, you will receive a notification at your registered email ID.
          If any further information is required or if there’s an issue, please contact us at:
        </p>

        <p className="font-semibold text-green-700 mb-2">📧 hr@suwashti.com</p>

        <div className="mt-6">
          <a href="/home" className="inline-block bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-full transition">
            Go to Homepage
          </a>
        </div>
      </div>
    </div>
  );
}

export default EmployeeThankYou;